"use client"
import React from "react";
import CustomModal from "./CustomModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { closeYTVideoModal } from "@/redux/features/ytVideoModal/ytVideoModalSlice";
import { getYTVideoId } from "@/utils/commonFunctions";

export default function YTVideoPlayerModal() {
  const dispatch = useDispatch();

  const { isOpen, video } = useSelector((state: RootState) => state.ytVideoModal);

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={() => dispatch(closeYTVideoModal())}
      isBlurOverlay
      showCloseButton={false}
      maxSize="max-w-[750px] aspect-video"
      className="rounded-t-xl sm:rounded-xl h-56 sm:h-full"
    >
      {video?.video_url ? (
        <iframe
          width="215"
          height="120"
          src={`https://www.youtube.com/embed/${getYTVideoId(video?.video_url)}?autoplay=1`}
          title={`YouTube video about ${video.title ?? "Mutual Fund"}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="block mx-auto w-full h-full object-contain rounded-t-md sm:rounded-md shrink-0"
        />
      ) : (
        <div className="text-xl text-black text-center font-medium bg-black py-15">
          The video is currently unavailable.
        </div>
      )}
    </CustomModal>
  );
}
